import { QuestionInterface } from '../interfaces/question.interface';
import { JsonObject, JsonProperty } from 'json2typescript';
import { OptionInterface } from './../interfaces/option.interface';
import { OptionModel } from './option.model';

@JsonObject('QuestionModel')
export class QuestionModel implements QuestionInterface {
  @JsonProperty('AnswerType', String, true)
  answerType: string = undefined;

  @JsonProperty('Description', String, true)
  description: string = undefined;

  @JsonProperty('Header', String, true)
  header: string = undefined;

  @JsonProperty('Groups', [QuestionModel], true)
  groups: QuestionModel[] = [];

  @JsonProperty('Id', Number, true)
  id: number = undefined;

  @JsonProperty('IsMandatory', Boolean, true)
  isMandatory: boolean = false;

  @JsonProperty('IsVisible', Boolean, true)
  isVisible: boolean = true;

  @JsonProperty('Number', Number, true)
  number: number = undefined;

  @JsonProperty('Order', Number, true)
  order: number = undefined;

  @JsonProperty('Options', [OptionModel], true)
  options: OptionInterface[] = [];

  @JsonProperty('QuestionRenderType', String, true)
  questionRenderType: string = undefined;

  @JsonProperty('QuestionType', String, true)
  questionType: string = undefined;

  @JsonProperty('IsOptionSelected', Boolean, true)
  isOptionSelected: boolean = false;
}
